<template>
  <div class="payment-header">
    <themed-price />
    <header-description />
    <header-logo :logo-desc-is-open.sync="logoDescIsOpen" />
    <transition-logo :logo-desc-is-open="logoDescIsOpen" />
  </div>
</template>

<script>
import Price from './Price';
import HeaderDescription from './HeaderDescription';
import HeaderLogo from './HeaderLogo';
import TransitionLogo from './TransitionLogo';
import styled from 'vue-styled-components';

const themedPrice = styled(Price)`
  color: var(--on_background);
  .payment-header__price__text {
    color: var(--on_background);
    opacity: 0.5;
  }
  .payment-header__price__amount {
    font-weight: normal;
    font-weight: var(--amount_text_weight);
    color: var(--on_background);
  }
`;

export default {
  name: 'PaymentHeaderComponent',

  components: {
    HeaderDescription,
    HeaderLogo,
    TransitionLogo,
    themedPrice,
  },

  data() {
    return {
      logoDescIsOpen: false,
    };
  },
};
</script>
